export default {
  page: {
    title: 'Break text into lines',
    subtitle: 'Tools',
  },
  card: {
    title: 'Break settings',
  },
  form: {
    options: {
      title: 'Default settings',
      removeAccents: 'Remove accents',
      removeDuplicates: 'Remove duplicates',
      sortAlphabetically: 'Sort list',
      minWordLength: {
        label: 'Ignore words with up to:',
        unit: 'letters',
        tooltip:
          'Words with this many letters or fewer will be ignored.',
      },
    },
    text: {
      label: 'Text:',
    },
    result: {
      label: 'Generated text:',
    },
    totalWords: {
      label: 'Total words:',
    },
    ignored: {
      label: 'Ignored:',
    },
  },
  button: {
    download: 'Download',
  },
  alert: {
    noWordsFound:
      'No words found with more than {count} letters.',
  },
};
